import { render, staticRenderFns } from "./ShowLinkDialog.vue?vue&type=template&id=318c3a16&scoped=true"
import script from "./ShowLinkDialog.vue?vue&type=script&lang=js"
export * from "./ShowLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowLinkDialog.vue?vue&type=style&index=0&id=318c3a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c3a16",
  null
  
)

export default component.exports